import React from 'react';
import { errorText } from '../../../lib/apiErrors';
import WikiIcon from './WikiIcon';

/**
 * Loading / error / empty / no-access states for Wiki surfaces. The
 * prototype has none (it runs on seed data); these keep the real build honest
 * and use the CRM type scale. Wrap in `.wk-card` when the state replaces a card.
 */

export function WikiLoading({ label = 'Loading…', className = '' }) {
    return (
        <div className={`wk-state ${className}`.trim()} role="status" aria-live="polite">
            <div className="wk-spinner" aria-hidden="true" />
            <p className="wk-t-meta">{label}</p>
        </div>
    );
}

export function WikiError({ error, onRetry, title = "This didn't load.", className = '' }) {
    return (
        <div className={`wk-state wk-state--error ${className}`.trim()} role="alert">
            <span className="wk-state-icon" aria-hidden="true"><WikiIcon name="alert-triangle" size={18} /></span>
            <p className="wk-t-name">{title}</p>
            <p className="wk-t-meta wk-state-detail">{errorText(error, 'Please try again.')}</p>
            {onRetry && (
                <div className="wk-state-actions">
                    <button type="button" className="wk-btn wk-btn--secondary wk-btn--sm" onClick={onRetry}>
                        <WikiIcon name="refresh-cw" size={14} /> Try again
                    </button>
                </div>
            )}
        </div>
    );
}

export function WikiEmpty({ icon = 'file-text', title, detail, action, className = '' }) {
    return (
        <div className={`wk-state ${className}`.trim()}>
            <span className="wk-state-icon" aria-hidden="true"><WikiIcon name={icon} size={18} /></span>
            {title && <p className="wk-t-name">{title}</p>}
            {detail && <p className="wk-t-meta wk-state-detail">{detail}</p>}
            {action && <div className="wk-state-actions">{action}</div>}
        </div>
    );
}

export function WikiNoAccess({
    title = "You don't have access to the Wiki",
    detail = 'Ask a Wiki admin to give your role access.',
    className = '',
}) {
    return (
        <div className={`wk-state ${className}`.trim()} role="status">
            <span className="wk-state-icon" aria-hidden="true"><WikiIcon name="lock" size={18} /></span>
            <p className="wk-t-name">{title}</p>
            <p className="wk-t-meta wk-state-detail">{detail}</p>
        </div>
    );
}
